import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useThemeContext } from '../../context/ThemeContext';

interface DateSeparatorProps {
  date: Date;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  const { mode } = useThemeContext();
  
  // Format date
  const formattedDate = date.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  
  // Determine if date is today, yesterday, or other
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  
  const isToday = date.toDateString() === today.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();
  
  let displayDate = formattedDate;
  if (isToday) {
    displayDate = 'Today';
  } else if (isYesterday) {
    displayDate = 'Yesterday';
  }
  
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      my: 2,
      px: 2
    }}>
      <Divider sx={{ 
        flexGrow: 1,
        ...(mode === 'dark' && { 
          bgcolor: 'rgba(255, 255, 255, 0.1)' 
        })
      }} />
      <Typography 
        variant="caption" 
        color="text.secondary"
        sx={{ 
          px: 2,
          py: 0.5, 
          borderRadius: 1,
          backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'background.paper',
          fontSize: '0.75rem',
          fontWeight: 500
        }}
      >
        {displayDate}
      </Typography>
      <Divider sx={{ 
        flexGrow: 1,
        ...(mode === 'dark' && { 
          bgcolor: 'rgba(255, 255, 255, 0.1)' 
        })
      }} />
    </Box>
  );
};

export default DateSeparator;